// @ts-nocheck
import { Game } from "./game-base";
import { Sound } from "../audio";
import { SLOT_ORDER, SPELLS, keyLabelForSlot } from "../data";
import { escapeHtml } from "../net-ui";
import { drawSpellIcon, spellHasIconAsset } from "../spell-icons";

const LEARN_VOID_PREVIEW = "learn_void";
const LEARN_MOVE_PREVIEW = "learn_move";
const LEARN_BLIZZARD_PREVIEW = "learn_blizzard";
const LEARN_COMBO_PREVIEW = "learn_combo";
const LEARN_VOIDRIP_HELL_PREVIEW = "learn_voidrip_hell";
const LEARN_SYNERGY_BASE_KIND = "voidrip_base";
const LEARN_SYNERGY_HELL_KIND = "voidrip_hell";
// Keep in sync with server/sim/preview_games.go learnBlizz*.
const LEARN_BLIZZ_LOOP = 6.5;
const LEARN_BLIZZ_APPROACH = 0.9;
const LEARN_BLIZZ_CAST_AT = 1.1;
const LEARN_BLIZZ_RETREAT = 1.3;
const LEARN_BLIZZ_CURSOR_START = { x: -150, y: 35 };
const LEARN_BLIZZ_CURSOR_CAST = { x: 70, y: 0 };
const LEARN_BLIZZ_CURSOR_RETREAT = { x: -90, y: -145 };
// Keep in sync with server/sim/preview_games.go learnCombo*.
const LEARN_COMBO_LOOP = 12.0;
const LEARN_COMBO_CURSOR_START = { x: -90, y: -185 };
const LEARN_COMBO_CENTER = { x: 0, y: -5 };
const LEARN_COMBO_FW_AIM = { x: 0, y: 42 };
const LEARN_COMBO_ENEMIES = [
  { x: 0, y: -95 },
  { x: -68, y: 42 },
  { x: 68, y: 42 },
];
const LEARN_COMBO_CASTS = [
  { castAt: 2.0, spell: "fireball", slot: "1", aim: LEARN_COMBO_ENEMIES[0] },
  { castAt: 3.4, spell: "firewall", slot: "Q", aim: LEARN_COMBO_FW_AIM },
  { castAt: 5.4, spell: "teleport", slot: "Space", aim: LEARN_COMBO_CENTER },
  { castAt: 6.2, spell: "frostnova", slot: "2", aimSelf: true },
];
const LEARN_COMBO_HOTKEYS = [
  { spell: "fireball", slot: "1", castAt: 2.0 },
  { spell: "frostnova", slot: "2", castAt: 6.2 },
  { spell: "firewall", slot: "Q", castAt: 3.4 },
  { spell: "teleport", slot: "Space", castAt: 5.4 },
];
const LEARN_HOTKEY_PRESS_DUR = 0.42;
const LEARN_MOVE_WAYPOINTS = [
  { x: -55, y: -35 },
  { x: 65, y: -25 },
  { x: 45, y: 45 },
  { x: -40, y: 35 },
];
const LEARN_MOVE_SEG = 2.0;
const LEARN_MOVE_HOVER = 0.5;
const LEARN_PREVIEW_VIEW_R = 210;
const LEARN_PREVIEW_MIN_DT = 1 / 20;
const LEARN_PREVIEW_IDLE_LABEL = "hover me";
const LEARN_PREVIEW_RENDER = { lite: true };

Game.prototype.renderLearnSkills = function () {
  const el = document.getElementById("learnSkillsKeys");
  if (!el) return;
  el.innerHTML = SLOT_ORDER.map(slot =>
    `<span class="k">${escapeHtml(keyLabelForSlot(slot))}</span>`
  ).join(" ");
};

Game.prototype._learnPreviewEmptyCarry = function () {
  return {
    blizzards: [], firewalls: [], icewalls: [], hellrips: [],
    particles: [], shockwaves: [], beams: [], armPops: [], spellSpritePops: [], dmgPopups: [],
  };
};

Game.prototype._learnPreviewDrawIdle = function (preview) {
  if (!preview?.ctx) return;
  const c = preview.ctx;
  c.fillStyle = "#05060d";
  c.fillRect(0, 0, preview.w, preview.h);
  c.fillStyle = "#7a7398";
  c.font = "600 15px Trebuchet MS, sans-serif";
  c.textAlign = "center";
  c.textBaseline = "middle";
  c.fillText(LEARN_PREVIEW_IDLE_LABEL, preview.w / 2, preview.h / 2);
  if (preview.fillEl) preview.fillEl.style.width = "0%";
};

Game.prototype._learnPreviewResetState = function (preview) {
  preview.elapsed = 0;
  preview.inited = false;
  if (preview.dual) {
    preview.carryBase = this._learnPreviewEmptyCarry();
    preview.carryHell = this._learnPreviewEmptyCarry();
  } else {
    preview.carry = this._learnPreviewEmptyCarry();
  }
};

Game.prototype._learnPreviewSyncActive = function () {
  const hub = this._learnPreviewHub;
  if (!hub?.active) return;
  hub.playing = hub.previews.find(p => p.hovered) || null;
  for (const preview of hub.previews) {
    if (preview !== hub.playing) this._learnPreviewDrawIdle(preview);
  }
  if (!hub.playing) this._learnPreviewStopLoop();
  else this._syncLearnPreviewLoop();
};

Game.prototype._learnPreviewScheduleNext = function (delayMs) {
  const hub = this._learnPreviewHub;
  if (!hub?.active || hub.paused) return;
  if (hub.timer) clearTimeout(hub.timer);
  hub.timer = setTimeout(() => {
    hub.timer = null;
    if (hub.active && !hub.paused && hub.playing) {
      hub.raf = requestAnimationFrame((t) => this._learnPreviewTick(t));
    }
  }, Math.max(0, delayMs));
};

Game.prototype._learnPreviewStopLoop = function () {
  const hub = this._learnPreviewHub;
  if (!hub) return;
  if (hub.raf) {
    cancelAnimationFrame(hub.raf);
    hub.raf = null;
  }
  if (hub.timer) {
    clearTimeout(hub.timer);
    hub.timer = null;
  }
};

Game.prototype._learnPreviewOnVisibility = function () {
  const hub = this._learnPreviewHub;
  if (!hub?.active) return;
  hub.paused = document.hidden;
  if (hub.paused) this._learnPreviewStopLoop();
  else this._learnPreviewSyncActive();
};

Game.prototype._syncLearnPreviewLoop = function () {
  const hub = this._learnPreviewHub;
  if (!hub?.active || hub.paused) return;
  if (hub.playing && !hub.raf && !hub.timer) {
    hub.lastStepT = performance.now() / 1000;
    hub.raf = requestAnimationFrame((t) => this._learnPreviewTick(t));
  }
};

Game.prototype._initLearnPreview = function (preview) {
  if (preview.inited) return true;
  if (typeof window.wpreviewLearnReset !== "function") return false;
  if (preview.dual) {
    if (!window.wpreviewLearnReset(LEARN_SYNERGY_BASE_KIND, "voidrip")) return false;
    if (!window.wpreviewLearnReset(LEARN_SYNERGY_HELL_KIND, LEARN_VOIDRIP_HELL_PREVIEW)) return false;
  } else if (!window.wpreviewLearnReset(preview.previewKind, preview.previewId)) {
    return false;
  }
  preview.inited = true;
  if (!preview.dual && typeof window.wpreviewLearnLoop === "function") {
    const loop = window.wpreviewLearnLoop(preview.previewKind);
    if (loop) preview.loop = loop;
  }
  return true;
};

Game.prototype._stepLearnWasmPreview = function (preview, dt) {
  const raw = window.wpreviewLearnStep(preview.previewKind, dt);
  let msg;
  try { msg = JSON.parse(raw); } catch (e) { return; }
  if (!msg || !Array.isArray(msg.p)) return;
  if (msg.loop) preview.loop = msg.loop;
  preview.elapsed += dt;
  try {
    this.renderSimPreview(preview.ctx, preview.w, preview.h, msg, dt, preview.carry, preview.renderOpts || LEARN_PREVIEW_RENDER);
    if (preview.overlay) preview.overlay.call(this, preview.ctx, preview.w, preview.h, msg, preview.elapsed);
  } catch (err) {
    console.warn(`learn preview ${preview.previewId} render failed:`, err);
  }
};

Game.prototype._stepLearnSynergyPreview = function (preview, dt) {
  let msgBase, msgHell;
  try {
    msgBase = JSON.parse(window.wpreviewLearnStep(LEARN_SYNERGY_BASE_KIND, dt));
    msgHell = JSON.parse(window.wpreviewLearnStep(LEARN_SYNERGY_HELL_KIND, dt));
  } catch (e) {
    return;
  }
  if (!msgBase?.p || !msgHell?.p) return;
  if (msgBase.loop) preview.loop = msgBase.loop;
  if (msgHell.loop && msgHell.loop > preview.loop) preview.loop = msgHell.loop;
  preview.elapsed += dt;

  const { ctx, canvas, halfW } = preview;
  ctx.fillStyle = "#05060d";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  try {
    ctx.save();
    ctx.beginPath();
    ctx.rect(0, 0, halfW, canvas.height);
    ctx.clip();
    this.renderSimPreview(ctx, halfW, canvas.height, msgBase, dt, preview.carryBase, LEARN_PREVIEW_RENDER);
    ctx.restore();

    ctx.save();
    ctx.beginPath();
    ctx.rect(halfW, 0, halfW, canvas.height);
    ctx.clip();
    ctx.translate(halfW, 0);
    this.renderSimPreview(ctx, halfW, canvas.height, msgHell, dt, preview.carryHell, LEARN_PREVIEW_RENDER);
    ctx.restore();

    ctx.save();
    ctx.strokeStyle = "rgba(150, 130, 255, 0.35)";
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(halfW + 0.5, 0);
    ctx.lineTo(halfW + 0.5, canvas.height);
    ctx.stroke();
    ctx.restore();
  } catch (err) {
    console.warn("learn synergy preview render failed:", err);
  }
};

Game.prototype._learnPreviewTick = function (now) {
  const hub = this._learnPreviewHub;
  if (!hub?.active || hub.paused) return;
  hub.raf = null;

  const active = hub.playing;
  if (!active?.hovered) return;

  const nowS = now / 1000;
  const sinceLast = nowS - hub.lastStepT;
  if (sinceLast < LEARN_PREVIEW_MIN_DT) {
    this._learnPreviewScheduleNext((LEARN_PREVIEW_MIN_DT - sinceLast) * 1000);
    return;
  }
  const dt = Math.min(0.05, sinceLast);
  hub.lastStepT = nowS;

  if (typeof window.wpreviewLearnStep !== "function") return;

  if (this._initLearnPreview(active)) {
    if (active.dual) this._stepLearnSynergyPreview(active, dt);
    else this._stepLearnWasmPreview(active, dt);
    if (active.fillEl && active.loop > 0) {
      active.fillEl.style.width = ((active.elapsed % active.loop) / active.loop * 100) + "%";
    }
  }

  this._learnPreviewScheduleNext(LEARN_PREVIEW_MIN_DT * 1000);
};

Game.prototype.setupLearnPreviews = function () {
  this.teardownLearnPreviews();
  if (typeof window.wpreviewLearnReset !== "function" || typeof window.wpreviewLearnStep !== "function") return;

  const specs = [
    {
      previewId: LEARN_MOVE_PREVIEW,
      previewKind: "move",
      canvasId: "learnMoveCanvas",
      fillId: "learnMoveLoopFill",
      overlay(ctx, w, h, msg, elapsed) {
        this.drawLearnMoveOverlay(ctx, w, h, msg, elapsed);
      },
    },
    {
      previewId: LEARN_VOID_PREVIEW,
      previewKind: "void",
      canvasId: "learnVoidCanvas",
      fillId: "learnVoidLoopFill",
      renderOpts: { lite: true, showPlatform: true },
    },
    {
      previewId: LEARN_BLIZZARD_PREVIEW,
      previewKind: "blizzard",
      canvasId: "learnBlizzardCanvas",
      fillId: "learnBlizzardLoopFill",
      overlay(ctx, w, h, msg, elapsed) {
        this.drawLearnBlizzardOverlay(ctx, w, h, msg, elapsed);
      },
    },
    {
      previewId: LEARN_COMBO_PREVIEW,
      previewKind: "combo",
      canvasId: "learnComboCanvas",
      fillId: "learnComboLoopFill",
      overlay(ctx, w, h, msg, elapsed) {
        this.drawLearnComboOverlay(ctx, w, h, msg, elapsed);
      },
    },
    {
      dual: true,
      canvasId: "learnSynergyCanvas",
      fillId: "learnSynergyLoopFill",
      loop: 5.8,
    },
  ];

  const previews = [];
  for (const spec of specs) {
    const canvas = document.getElementById(spec.canvasId);
    if (!canvas) continue;
    const ctx = canvas.getContext("2d");
    if (!ctx) continue;
    const stage = canvas.closest(".learn-preview-stage");
    if (!stage) continue;

    const preview = {
      ...spec,
      stage,
      canvas,
      ctx,
      w: canvas.width,
      h: canvas.height,
      fillEl: spec.fillId ? document.getElementById(spec.fillId) : null,
      hovered: false,
      inited: false,
      elapsed: 0,
      loop: spec.loop || 6.5,
    };
    if (preview.dual) {
      preview.halfW = Math.floor(canvas.width / 2);
      preview.carryBase = this._learnPreviewEmptyCarry();
      preview.carryHell = this._learnPreviewEmptyCarry();
    } else {
      preview.carry = this._learnPreviewEmptyCarry();
    }
    stage._learnPreview = preview;
    this._learnPreviewDrawIdle(preview);
    const onEnter = () => {
      preview.hovered = true;
      this._learnPreviewResetState(preview);
      this._learnPreviewSyncActive();
    };
    const onLeave = () => {
      preview.hovered = false;
      this._learnPreviewSyncActive();
    };
    preview.onEnter = onEnter;
    preview.onLeave = onLeave;
    stage.addEventListener("mouseenter", onEnter);
    stage.addEventListener("mouseleave", onLeave);
    previews.push(preview);
  }
  if (!previews.length) return;

  const hub = {
    active: true, paused: document.hidden, playing: null, previews,
    raf: null, timer: null, lastStepT: 0, onVisibility: null,
  };
  this._learnPreviewHub = hub;

  hub.onVisibility = () => this._learnPreviewOnVisibility();
  document.addEventListener("visibilitychange", hub.onVisibility);
};

Game.prototype.teardownLearnPreviews = function () {
  const hub = this._learnPreviewHub;
  if (!hub) return;
  hub.active = false;
  this._learnPreviewStopLoop();
  if (hub.onVisibility) {
    document.removeEventListener("visibilitychange", hub.onVisibility);
  }
  for (const preview of hub.previews) {
    if (preview.stage) {
      if (preview.onEnter) preview.stage.removeEventListener("mouseenter", preview.onEnter);
      if (preview.onLeave) preview.stage.removeEventListener("mouseleave", preview.onLeave);
      delete preview.stage._learnPreview;
    }
  }
  this._learnPreviewHub = null;
};

Game.prototype.stopLearnPreviews = function () {
  this.teardownLearnPreviews();
  if (this._learnSfxSuppressed) {
    Sound.popSfxSuppress();
    this._learnSfxSuppressed = false;
  }
};

Game.prototype.showLearn = function () {
  this.homeView = "learn";
  this.stopRoomPoll();
  window.SpellPreview?.hide?.();
  this.stopLearnPreviews();
  this.hide("menu"); this.hide("findGame"); this.hide("matchmaker"); this.hide("soloSetup"); this.hide("signInPanel");
  this.hide("keybinds"); this.hide("historyPanel"); this.hide("creditsPanel"); this.hide("spellbook");
  this.syncPatchNotesWidget?.(false);
  this.syncProfileWidget?.(false);
  this.closeReportCenter();
  this.renderLearnSkills();
  if (!this._learnSfxSuppressed) {
    Sound.pushSfxSuppress();
    this._learnSfxSuppressed = true;
  }
  this.show("learnPanel");
  this.setupLearnPreviews();
};

Game.prototype.learnBack = function () {
  this.stopLearnPreviews();
  window.SpellPreview?.hide?.();
  this.hide("learnPanel");
  if (this.alphaConfig?.phase === "scheduled") {
    this.showAlphaScheduledSplash();
    return;
  }
  this.showHome();
};

Game.prototype.openLearnSpellbook = function () {
  this.stopLearnPreviews();
  window.SpellPreview?.hide?.();
  this.hide("learnPanel");
  this.showSpellbook("learn");
};

Game.prototype.openLearnKeybinds = function () {
  this.stopLearnPreviews();
  window.SpellPreview?.hide?.();
  this.hide("learnPanel");
  this.showKeybinds("learn");
};

Game.prototype.learnPreviewWorldToScreen = function (ctx, w, h, msg, wx, wy) {
  const camX = msg.camX ?? 0;
  const camY = msg.camY ?? 0;
  const scale = (Math.min(w, h) / 2) / LEARN_PREVIEW_VIEW_R;
  return {
    x: w / 2 + (wx - camX) * scale,
    y: h / 2 + (wy - camY) * scale,
  };
};

Game.prototype.learnBlizzardCursorWorld = function (elapsed) {
  const s = LEARN_BLIZZ_CURSOR_START;
  const c = LEARN_BLIZZ_CURSOR_CAST;
  const r = LEARN_BLIZZ_CURSOR_RETREAT;
  if (elapsed < LEARN_BLIZZ_APPROACH) {
    const u = elapsed / LEARN_BLIZZ_APPROACH;
    return { x: s.x + (c.x - s.x) * u, y: s.y + (c.y - s.y) * u };
  }
  if (elapsed < LEARN_BLIZZ_CAST_AT) return { ...c };
  if (elapsed < LEARN_BLIZZ_CAST_AT + LEARN_BLIZZ_RETREAT) {
    const u = (elapsed - LEARN_BLIZZ_CAST_AT) / LEARN_BLIZZ_RETREAT;
    return { x: c.x + (r.x - c.x) * u, y: c.y + (r.y - c.y) * u };
  }
  return { ...r };
};

Game.prototype.drawLearnHotkeySlot = function (ctx, bx, restY, size, spellId, slot, opts) {
  const { pressed, cdLeft, cdMax } = opts;
  const s = SPELLS[spellId];
  const color = s?.color || "#8a86a6";
  const key = keyLabelForSlot(slot);
  const by = restY + (pressed ? 2 : 0);
  const onCd = cdLeft > 0 && cdMax > 0;

  ctx.save();
  if (!pressed) {
    ctx.fillStyle = "rgba(0,0,0,0.38)";
    ctx.beginPath();
    ctx.roundRect(bx + 1, restY + 3, size, size, 10);
    ctx.fill();
  }

  ctx.fillStyle = pressed ? "rgba(8,6,20,0.96)" : "rgba(15,12,32,0.9)";
  ctx.strokeStyle = color;
  ctx.lineWidth = pressed ? 3 : 2;
  ctx.globalAlpha = onCd && !pressed ? 0.55 : 1;
  ctx.beginPath();
  ctx.roundRect(bx, by, size, size, 10);
  ctx.fill();
  ctx.stroke();
  ctx.globalAlpha = 1;

  if (pressed) {
    ctx.fillStyle = "rgba(0,0,0,0.32)";
    ctx.fillRect(bx + 2, by + 2, size - 4, (size - 4) * 0.5);
  }

  const icX = bx + size / 2;
  const icY = by + size / 2 - 2;
  if (!drawSpellIcon(ctx, icX, icY, size * 0.78, spellId) && !spellHasIconAsset(spellId)) {
    ctx.font = `${Math.round(size * 0.48)}px sans-serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(s?.fallbackIcon || "?", icX, icY);
  }

  if (onCd) {
    const frac = Math.min(1, cdLeft / cdMax);
    ctx.fillStyle = "rgba(0,0,0,0.62)";
    ctx.fillRect(bx + 1, by + 1, size - 2, (size - 2) * frac);
    ctx.fillStyle = "#fff";
    ctx.font = "600 12px Trebuchet MS, sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(cdLeft.toFixed(1), icX, icY);
  }

  ctx.font = "600 11px Trebuchet MS, sans-serif";
  ctx.textAlign = "left";
  ctx.textBaseline = "top";
  ctx.fillStyle = pressed ? "#fff" : "#cfc9f0";
  ctx.fillText(key, bx + 5, by + 4);
  ctx.restore();
};

Game.prototype.drawLearnHotkeyBar = function (ctx, w, h, t, slots, size, gap) {
  const totalW = slots.length * size + (slots.length - 1) * gap;
  let x = w / 2 - totalW / 2;
  const restY = h - size - 10;
  for (const sl of slots) {
    const s = SPELLS[sl.spell];
    const cdMax = s?.cooldown || 0;
    const cdLeft = sl.castAt >= 0 && t >= sl.castAt ? Math.max(0, cdMax - (t - sl.castAt)) : 0;
    const pressed = t >= sl.castAt && t < sl.castAt + LEARN_HOTKEY_PRESS_DUR;
    this.drawLearnHotkeySlot(ctx, x, restY, size, sl.spell, sl.slot, { pressed, cdLeft, cdMax });
    x += size + gap;
  }
};

Game.prototype.drawLearnBlizzardHotkeyButton = function (ctx, w, h, t) {
  this.drawLearnHotkeyBar(ctx, w, h, t, [
    { spell: "firewall", slot: "Q", castAt: LEARN_BLIZZ_CAST_AT },
  ], 46, 0);
};

Game.prototype.drawLearnBlizzardOverlay = function (ctx, w, h, msg, elapsed) {
  const loop = msg.loop || LEARN_BLIZZ_LOOP;
  const t = elapsed % loop;
  const cur = this.learnBlizzardCursorWorld(t);
  const screen = this.learnPreviewWorldToScreen(ctx, w, h, msg, cur.x, cur.y);

  ctx.save();
  if (t < LEARN_BLIZZ_CAST_AT) {
    ctx.strokeStyle = "rgba(140, 200, 255, 0.35)";
    ctx.lineWidth = 1.5;
    ctx.setLineDash([5, 6]);
    ctx.beginPath();
    const caster = msg.p && msg.p[0];
    if (caster) {
      const from = this.learnPreviewWorldToScreen(ctx, w, h, msg, caster.x, caster.y);
      ctx.moveTo(from.x, from.y);
      ctx.lineTo(screen.x, screen.y);
      ctx.stroke();
    }
    ctx.setLineDash([]);
  }

  if (t >= LEARN_BLIZZ_CAST_AT - 0.08 && t < LEARN_BLIZZ_CAST_AT + 0.55) {
    const age = t - LEARN_BLIZZ_CAST_AT;
    const pulse = age < 0 ? 1 : Math.max(0, 1 - age / 0.55);
    ctx.fillStyle = `rgba(255, 122, 47, ${0.15 + pulse * 0.45})`;
    ctx.strokeStyle = `rgba(255, 122, 47, ${0.35 + pulse * 0.55})`;
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.arc(screen.x, screen.y, 10 + (1 - pulse) * 18, 0, Math.PI * 2);
    ctx.fill();
    ctx.stroke();
  }

  ctx.fillStyle = "#f5f2ff";
  ctx.strokeStyle = "rgba(0,0,0,0.55)";
  ctx.lineWidth = 1.2;
  ctx.beginPath();
  ctx.moveTo(screen.x, screen.y);
  ctx.lineTo(screen.x + 14, screen.y + 18);
  ctx.lineTo(screen.x + 5, screen.y + 18);
  ctx.lineTo(screen.x + 5, screen.y + 28);
  ctx.lineTo(screen.x - 2, screen.y + 28);
  ctx.lineTo(screen.x - 2, screen.y + 18);
  ctx.lineTo(screen.x - 10, screen.y + 18);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();

  this.drawLearnBlizzardHotkeyButton(ctx, w, h, t);
};

Game.prototype.learnComboCursorWorld = function (elapsed) {
  const e0 = LEARN_COMBO_ENEMIES[0];
  const fw = LEARN_COMBO_FW_AIM;
  const center = LEARN_COMBO_CENTER;
  const start = LEARN_COMBO_CURSOR_START;
  if (elapsed < 1.7) {
    const u = elapsed / 1.7;
    return { x: start.x + (e0.x - start.x) * u, y: start.y + (e0.y - start.y) * u };
  }
  if (elapsed < 2.0) return { ...e0 };
  if (elapsed < 3.2) {
    const u = (elapsed - 2.0) / 1.2;
    return { x: e0.x + (fw.x - e0.x) * u, y: e0.y + (fw.y - e0.y) * u };
  }
  if (elapsed < 3.4) return { ...fw };
  if (elapsed < 5.2) {
    const u = (elapsed - 3.4) / 1.8;
    return { x: fw.x + (center.x - fw.x) * u, y: fw.y + (center.y - fw.y) * u };
  }
  return { ...center };
};

Game.prototype.drawLearnCastPulse = function (ctx, screen, castAt, t) {
  if (t < castAt - 0.08 || t >= castAt + 0.55) return;
  const age = t - castAt;
  const pulse = age < 0 ? 1 : Math.max(0, 1 - age / 0.55);
  ctx.save();
  ctx.fillStyle = `rgba(126, 232, 255, ${0.15 + pulse * 0.45})`;
  ctx.strokeStyle = `rgba(126, 232, 255, ${0.35 + pulse * 0.55})`;
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.arc(screen.x, screen.y, 10 + (1 - pulse) * 18, 0, Math.PI * 2);
  ctx.fill();
  ctx.stroke();
  ctx.restore();
};

Game.prototype.drawLearnMoveClickPulse = function (ctx, w, h, msg, wx, wy, segStart, t) {
  const age = t - segStart;
  if (age < 0 || age > 0.45) return;
  const pulse = Math.max(0, 1 - age / 0.45);
  const pt = this.learnPreviewWorldToScreen(ctx, w, h, msg, wx, wy);
  ctx.save();
  ctx.strokeStyle = `rgba(255, 200, 120, ${0.25 + pulse * 0.55})`;
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.arc(pt.x, pt.y, 8 + (1 - pulse) * 14, 0, Math.PI * 2);
  ctx.stroke();
  ctx.fillStyle = `rgba(255, 180, 90, ${pulse * 0.35})`;
  ctx.beginPath();
  ctx.arc(pt.x, pt.y, 5, 0, Math.PI * 2);
  ctx.fill();
  if (age < 0.35) {
    ctx.fillStyle = "rgba(255, 220, 160, 0.9)";
    ctx.font = "600 11px Trebuchet MS, sans-serif";
    ctx.textAlign = "center";
    ctx.fillText("click", pt.x, pt.y - 14);
  }
  ctx.restore();
};

Game.prototype.drawLearnComboOverlay = function (ctx, w, h, msg, elapsed) {
  const loop = msg.loop || LEARN_COMBO_LOOP;
  const t = elapsed % loop;
  const cur = this.learnComboCursorWorld(t);
  const screen = this.learnPreviewWorldToScreen(ctx, w, h, msg, cur.x, cur.y);
  const caster = msg.p && msg.p[0];

  ctx.save();
  if (caster) {
    const from = this.learnPreviewWorldToScreen(ctx, w, h, msg, caster.x, caster.y);
    ctx.strokeStyle = "rgba(140, 200, 255, 0.3)";
    ctx.lineWidth = 1.5;
    ctx.setLineDash([5, 6]);
    ctx.beginPath();
    ctx.moveTo(from.x, from.y);
    ctx.lineTo(screen.x, screen.y);
    ctx.stroke();
    ctx.setLineDash([]);
  }

  for (const cast of LEARN_COMBO_CASTS) {
    let aimPt;
    if (cast.aimSelf && caster) {
      aimPt = this.learnPreviewWorldToScreen(ctx, w, h, msg, caster.x, caster.y);
    } else {
      const aim = cast.aim || LEARN_COMBO_ENEMIES[0];
      aimPt = this.learnPreviewWorldToScreen(ctx, w, h, msg, aim.x, aim.y);
    }
    this.drawLearnCastPulse(ctx, aimPt, cast.castAt, t);
  }

  ctx.fillStyle = "#f5f2ff";
  ctx.strokeStyle = "rgba(0,0,0,0.55)";
  ctx.lineWidth = 1.2;
  ctx.beginPath();
  ctx.moveTo(screen.x, screen.y);
  ctx.lineTo(screen.x + 14, screen.y + 18);
  ctx.lineTo(screen.x + 5, screen.y + 18);
  ctx.lineTo(screen.x + 5, screen.y + 28);
  ctx.lineTo(screen.x - 2, screen.y + 28);
  ctx.lineTo(screen.x - 2, screen.y + 18);
  ctx.lineTo(screen.x - 10, screen.y + 18);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();

  this.drawLearnHotkeyBar(ctx, w, h, t, LEARN_COMBO_HOTKEYS, 38, 6);
};

Game.prototype.drawLearnMoveOverlay = function (ctx, w, h, msg, elapsed) {
  const loop = msg.loop || 8;
  const t = elapsed % loop;
  const n = LEARN_MOVE_WAYPOINTS.length;
  const seg = Math.floor(t / LEARN_MOVE_SEG) % n;
  const segT = t % LEARN_MOVE_SEG;
  const target = LEARN_MOVE_WAYPOINTS[seg];
  const prev = seg === 0 && elapsed < LEARN_MOVE_SEG
    ? { x: 0, y: 0 }
    : LEARN_MOVE_WAYPOINTS[(seg - 1 + n) % n];
  const hoverU = Math.min(1, segT / LEARN_MOVE_HOVER);
  const cursorWx = prev.x + (target.x - prev.x) * hoverU;
  const cursorWy = prev.y + (target.y - prev.y) * hoverU;
  const cursor = this.learnPreviewWorldToScreen(ctx, w, h, msg, cursorWx, cursorWy);
  const click = this.learnPreviewWorldToScreen(ctx, w, h, msg, target.x, target.y);

  ctx.save();
  if (segT < LEARN_MOVE_HOVER) {
    ctx.strokeStyle = "rgba(200, 190, 255, 0.35)";
    ctx.lineWidth = 1.5;
    ctx.setLineDash([5, 6]);
    ctx.beginPath();
    ctx.moveTo(cursor.x, cursor.y);
    ctx.lineTo(click.x, click.y);
    ctx.stroke();
    ctx.setLineDash([]);
  }

  if (segT >= LEARN_MOVE_HOVER - 0.05) {
    const clickAge = segT - LEARN_MOVE_HOVER;
    const pulse = Math.max(0, 1 - clickAge / 0.45);
    if (pulse > 0) {
      ctx.strokeStyle = `rgba(255, 200, 120, ${0.25 + pulse * 0.55})`;
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.arc(click.x, click.y, 8 + (1 - pulse) * 14, 0, Math.PI * 2);
      ctx.stroke();
      ctx.fillStyle = `rgba(255, 180, 90, ${pulse * 0.35})`;
      ctx.beginPath();
      ctx.arc(click.x, click.y, 5, 0, Math.PI * 2);
      ctx.fill();
    }
    if (segT >= LEARN_MOVE_HOVER && segT < LEARN_MOVE_HOVER + 0.35) {
      ctx.fillStyle = "rgba(255, 220, 160, 0.9)";
      ctx.font = "600 11px Trebuchet MS, sans-serif";
      ctx.textAlign = "center";
      ctx.fillText("click", click.x, click.y - 14);
    }
  }

  ctx.fillStyle = "#f5f2ff";
  ctx.strokeStyle = "rgba(0,0,0,0.55)";
  ctx.lineWidth = 1.2;
  ctx.beginPath();
  ctx.moveTo(cursor.x, cursor.y);
  ctx.lineTo(cursor.x + 14, cursor.y + 18);
  ctx.lineTo(cursor.x + 5, cursor.y + 18);
  ctx.lineTo(cursor.x + 5, cursor.y + 28);
  ctx.lineTo(cursor.x - 2, cursor.y + 28);
  ctx.lineTo(cursor.x - 2, cursor.y + 18);
  ctx.lineTo(cursor.x - 10, cursor.y + 18);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
};

